/* src/app/modules/spare-parts/subtable/subtable.component.scss */
:host {
  width: 100%;
}
.subtable-grid-container {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-template-areas: "subtable-headers" "subtable-rows";
}
.subtable-grid-common {
  display: grid;
  width: 100%;
}
.subtable-headers {
  grid-template-rows: 1fr;
}
.subtable-row-cell,
.subtable-header-cell {
  padding: 0.75rem 0.75rem;
}
.subtable-row-cell sh-text,
.subtable-header-cell sh-text {
  width: fit-content;
}
.subtable-header-cell:first-of-type,
.subtable-row-cell:first-of-type {
  padding-left: 4.25rem;
}
.subtable-rows {
  grid-template-rows: auto;
}
.part-number {
  display: flex;
  flex-flow: row nowrap;
  gap: 0.4rem;
}
.part-number sh-icon {
  visibility: hidden;
  cursor: pointer;
}
.part-number:hover {
  text-decoration: underline;
}
.part-number:hover sh-icon {
  visibility: visible;
}
sh-divider:last-of-type {
  display: none;
}
/*# sourceMappingURL=subtable.component.css.map */
